"use client";

import { COLUMNS_BY_TABLE, TABLES } from "@/constants";
import { makeUseDetails, makeUseInfinite, makeUseList } from "@/utils/queries";
import type { MerchantRow } from "..";

export const useMerchants = makeUseList<typeof TABLES.MERCHANTS, MerchantRow>({
  table: TABLES.MERCHANTS,
  options: {
    columns: [...COLUMNS_BY_TABLE[TABLES.MERCHANTS]],
    orderBy: { column: "name" },
  },
});

export const useMerchantsInfinite = makeUseInfinite<
  typeof TABLES.MERCHANTS,
  MerchantRow
>({
  table: TABLES.MERCHANTS,
  options: {
    columns: [...COLUMNS_BY_TABLE[TABLES.MERCHANTS]],
    orderBy: { column: "name" },
  },
});

export const useMerchantDetails = makeUseDetails<
  typeof TABLES.MERCHANTS,
  MerchantRow
>({
  table: TABLES.MERCHANTS,
  options: {
    columns: [...COLUMNS_BY_TABLE[TABLES.MERCHANTS]],
  },
});
